import { Grid, GridColumn, GridColumnProps } from "@progress/kendo-react-grid";
import s from "./SingleItemMarketInsightTable.module.scss";
import classNames from "classnames";
import { WatchlistBreakdown } from "@iliotech/watchlist-api";
import { ConnectedInformationButton } from "@widgets/components/ConnectedInformationButton/ConnectedInformationButton";

type DiscoveryTableColumnProps = GridColumnProps & {
  rightAligned?: boolean;
  removeBorderLeft?: boolean;
};

interface IOwnProps {
  data: any; // Single item
  activeColumns: DiscoveryTableColumnProps[];
  sortedItems: WatchlistBreakdown[];
}

export const SingleItemMarketInsightTable = ({
  data,
  activeColumns,
  sortedItems,
}: IOwnProps) => {
  const HeaderCell = (props: GridColumnProps) => {
    const isRsi = props.title!.includes("RSI");
    const actualTitle = isRsi
      ? props.title!.split("-")?.[0]?.trim()
      : props.title;
    let sortedItem = sortedItems?.find((item) => item.title === actualTitle);

    if (!sortedItem) {
      sortedItem = sortedItems?.find(
        (item) => item.title === actualTitle?.split(" -")[0]
      );
    }

    const getPeriodIndex = (sortedItem: WatchlistBreakdown) => {
      if (sortedItem?.chart?.length === 1 || !sortedItem?.chart) {
        return 0;
      }
      let adjustedTitle = props.title;
      const isCallOrPuts =
        props.title!.includes("Calls") || props.title!.includes("Puts");
      if (isCallOrPuts) {
        const titleWords = props.title!.split(" ");
        adjustedTitle = titleWords.slice(0, -2).join(" ");
      }
      const currentPeriod =
        adjustedTitle!.split("-")?.[1]?.trim().toLowerCase() || "";
      const allPeriods = sortedItem.chart.map((item) =>
        item.subTitle?.toLowerCase()
      );

      return allPeriods.indexOf(currentPeriod) === -1
        ? 0
        : allPeriods.indexOf(currentPeriod);
    };

    const periodIndex = getPeriodIndex(sortedItem!);
    const info = sortedItem?.chart[periodIndex].whyImportant;
    const textAlign =
      props.field === "Ranking" || props.field === "Ticker" ? "left" : "right";

    return (
      <div
        style={{
          textAlign,
          whiteSpace: "normal",
          verticalAlign: "middle",
        }}
      >
        <ConnectedInformationButton text={info!}>
          {props.title}
        </ConnectedInformationButton>
      </div>
    );
  };

  return (
    <div className={s.tableWrapper}>
      <Grid
        className={"grid-surround"}
        data={data}
        resizable={false}
        sortable={false}
      >
        {activeColumns?.map((col, index) => (
          <GridColumn
            headerCell={HeaderCell as any}
            headerClassName={classNames(col.rightAligned && s.rightAligned)}
            key={`col-${col.field}-${index}`}
            {...col}
          />
        ))}
      </Grid>
    </div>
  );
};
